import { useQuery } from "@tanstack/react-query";
import { getPlanningSettings } from "@/api/settings";
import { DEFAULT_TENANT_TZ } from "@/lib/date";

/**
 * Returns the tenant's configured IANA timezone from planning settings.
 *
 * Sources the value from the same TanStack Query cache used by the Planning
 * settings tab (`["settings-planning"]`) so a change saved there propagates to
 * route views. Falls back to `Europe/Minsk` while loading or when the value is
 * missing, so callers can always pass a non-empty zone to the formatter.
 */
export function useTenantTimezone(): string {
  const { data } = useQuery({
    queryKey: ["settings-planning"],
    queryFn: getPlanningSettings,
    staleTime: 5 * 60_000,
  });

  return data?.timezone || DEFAULT_TENANT_TZ;
}
